import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import { useWaitlist } from "@/components/WaitlistContext";
import { trackEvent } from "@/lib/analytics";
import { X } from "lucide-react";
import { cn } from "@/lib/cn";

const DISMISS_KEY = "conduit_sticky_dismissed";

export function StickyCtaBar() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === "1");
  const { openWaitlist } = useWaitlist();

  useEffect(() => {
    if (dismissed) return;

    const hero = document.querySelector("[data-hero]");
    if (!hero) return;

    const observer = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting),
      { threshold: 0 },
    );
    observer.observe(hero);
    return () => observer.disconnect();
  }, [dismissed]);

  if (dismissed || !visible) return null;

  function handleClick() {
    trackEvent("CTA_Click", { location: "sticky_bar" });
    openWaitlist();
  }

  function handleDismiss() {
    sessionStorage.setItem(DISMISS_KEY, "1");
    setDismissed(true);
  }

  return (
    <div
      className={cn(
        "fixed bottom-0 inset-x-0 z-50 border-t border-border/70 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80",
        "animate-in slide-in-from-bottom duration-300",
      )}
    >
      <div className="container flex h-14 items-center justify-between gap-4">
        <p className="hidden text-sm font-medium text-foreground sm:block">
          Ready to try your AI agent?
        </p>
        <div className="flex flex-1 items-center justify-end gap-2 sm:flex-none">
          <Button size="sm" onClick={handleClick}>
            Start free trial
          </Button>
          <button
            onClick={handleDismiss}
            aria-label="Dismiss"
            className="inline-flex h-8 w-8 items-center justify-center rounded-md text-muted-foreground hover:text-foreground hover:bg-accent"
          >
            <X aria-hidden="true" className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
